import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { buildCategoryNavigationPath } from "@faire/retailer-shared/categories/navigationPath";
import { logAssert } from "@faire/web--source/common/logging";
import { Route as UnknownRoute } from "@faire/web--source/ui/routing/Route";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { Route } from "@faire/web-api--source/Route";
import { props as c1SuppliersRouteProps } from "@faire/web-api--source/routes/suppliers/c1SuppliersUrlId";
import { props as c1SuppliersBrandValueRouteProps } from "@faire/web-api--source/routes/suppliers/c1SuppliersUrlId/brand-value/brandValue";
import { props as c2SuppliersRouteProps } from "@faire/web-api--source/routes/suppliers/c1SuppliersUrlId/subcategory/c2SuppliersUrlId";
import { props as c3SuppliersRouteProps } from "@faire/web-api--source/routes/suppliers/c1SuppliersUrlId/subcategory/c2SuppliersUrlId/c3SuppliersUrlId";
import React, { Suspense } from "react";
import { Redirect } from "react-router-dom";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { fromUrlIds } from "@faire/retailer/models/Category/fromUrlIds";
import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { useCategoryStore } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore";
import { getCategoryRedirect } from "@faire/retailer/stores/domain/CategoryStore/getCategoryRedirect";
import { CategoryRouter } from "@faire/retailer/views/category/CategoryRouter";
import { LazySuppliersPage } from "@faire/retailer/views/suppliers/LazySuppliersPage";
import { SuppliersPageLoadingSkeleton } from "./SuppliersPageLoadingSkeleton/SuppliersPageLoadingSkeleton";
var suppliersRoutes = [
    c3SuppliersRouteProps,
    c2SuppliersRouteProps,
    c1SuppliersRouteProps,
    c1SuppliersBrandValueRouteProps
];
export var SuppliersRouter = function() {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    return /*#__PURE__*/ _jsxs(Switch, {
        children: [
            isLoggedInRetailer ? /*#__PURE__*/ _jsx(UnknownRoute, {
                path: "/suppliers/All Brands",
                component: CategoryRouter
            }) : null,
            /*#__PURE__*/ _jsx(UnknownRoute, {
                path: "/suppliers",
                component: SuppliersRouterInner
            })
        ]
    });
};
var SuppliersRouterInner = function() {
    // before rendering the component, we need to make sure the category tree is loaded
    var categoriesLoading = useCategoryStore().categoriesLoading;
    if (categoriesLoading) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: /*#__PURE__*/ _jsx(SuppliersPageLoadingSkeleton, {}),
        children: /*#__PURE__*/ _jsx(Switch, {
            children: suppliersRoutes.map(function(route) {
                return /*#__PURE__*/ _createElement(Route, _object_spread_props(_object_spread({}, route), {
                    exact: true,
                    key: route.path,
                    component: SuppliersPageRenderer
                }));
            })
        })
    });
};
var SuppliersPageRenderer = function(param) {
    var match = param.match, location = param.location;
    var categoryUrlIds = extractSuppliersUrlIds(match.params);
    var categories = useCategoryStore().categories;
    var routingContext = useRetailerRoutingContext();
    var category = fromUrlIds(categoryUrlIds, categories !== null && categories !== void 0 ? categories : []);
    logAssert(!!category, "Category creation failed on url, Pathname: ".concat(location.pathname, ". Search: ").concat(location.search));
    var categoryRedirectUrl = getCategoryRedirect(category, {
        location: location,
        match: match
    }, categories !== null && categories !== void 0 ? categories : [], routingContext);
    if (categoryRedirectUrl !== undefined) {
        return /*#__PURE__*/ _jsx(Redirect, {
            to: categoryRedirectUrl
        });
    }
    var mostSpecificPathIdentifier = category.mostSpecificPathIdentifier;
    var c1SuppliersUrlId = categoryUrlIds[0];
    var key = "".concat(mostSpecificPathIdentifier).concat(c1SuppliersUrlId);
    var navigationPath = buildCategoryNavigationPath(categoryUrlIds);
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: /*#__PURE__*/ _jsx(SuppliersPageLoadingSkeleton, {}),
        children: /*#__PURE__*/ _jsx(LazySuppliersPage, {
            category: category,
            navigationPath: navigationPath
        }, key)
    });
};
var extractSuppliersUrlIds = function(param) {
    var c1SuppliersUrlId = param.c1SuppliersUrlId, c2SuppliersUrlId = param.c2SuppliersUrlId, c3SuppliersUrlId = param.c3SuppliersUrlId;
    return [
        c1SuppliersUrlId !== null && c1SuppliersUrlId !== void 0 ? c1SuppliersUrlId : "",
        c2SuppliersUrlId !== null && c2SuppliersUrlId !== void 0 ? c2SuppliersUrlId : "",
        c3SuppliersUrlId !== null && c3SuppliersUrlId !== void 0 ? c3SuppliersUrlId : ""
    ].filter(function(c) {
        return c !== "";
    }).map(decodeURIComponent);
};
